import React, { useState } from 'react';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import ResellerPlanColumns from './resellerPlanColumns';
import './resellerPlansWidget.scss';

function ResellerPlansWidget() {
    const [key, setKey] = useState('one');

    return (
        <div className="reseller-plans-columns-wrapper">
            <Row className="mb-3">
                <Col md={12} className="text-center">
                    <Tabs id="plans-tabs" activeKey={key} onSelect={(k) => setKey(k)}>
                        <Tab eventKey="one" title="">
                            <ResellerPlanColumns />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </div>
    );
}

export default ResellerPlansWidget;
